import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import StepsLayout from '../../app/common/StepsLayout';

const ThankYouPageNtai = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <StepsLayout>
      <Box display="flex" alignItems="center" mb={3}>
        <CheckCircleIcon sx={{ fontSize: 84, mr: 2, color: '#85b4cd' }} />
        <Typography component="h1" variant="h3" className="steps-header">
          Thank You!
        </Typography>
      </Box>

      <Box
        style={{
          backgroundColor: 'white',
          padding: '50px 30px 30px 30px',
          borderRadius: '10px',
        }}
        sx={{ mt: 3 }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: 'bold', mb: 3 }}
        >
          Your NTAI Report is Being Processed
        </Typography>

        <Typography variant="body1" paragraph sx={{ color: '#555', mb: 3 }}>
          Thank you for completing your assessment! Your NTAI report is
          currently being generated and will be ready shortly.
        </Typography>

        <Typography variant="body1" paragraph sx={{ color: '#555', mb: 3 }}>
          You will receive an email with your results in a few minutes. Please
          be patient while we process your information.
        </Typography>

        <Box
          sx={{
            border: '2px solid #85b4cd',
            borderRadius: '10px',
            padding: '30px',
            backgroundColor: '#f9fcfe',
            mb: 3,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 'bold', color: '#85b4cd' }}
          >
            What happens next?
          </Typography>
          <Typography variant="body1" sx={{ color: '#555' }}>
            Once your report is ready, you'll receive a detailed email with your
            comprehensive NTAI assessment results. Make sure to check your inbox
            and spam folder.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button
            onClick={handleGoHome}
            variant="contained"
            style={{
              fontSize: '17px',
              borderRadius: '9px',
              backgroundColor: '#85b4cd',
              padding: '12px 30px',
            }}
            sx={{ '&:hover': { backgroundColor: '#6a9ab8' } }}
          >
            Go to Home
          </Button>
        </Box>

        <Typography
          variant="body2"
          sx={{
            color: '#888',
            fontStyle: 'italic',
            mt: 4,
            textAlign: 'center',
          }}
        >
          If you don't receive your report within 10 minutes, please contact
          info@pompaprogram.com
        </Typography>
      </Box>
    </StepsLayout>
  );
};

export default ThankYouPageNtai;
